import { api } from '../api';
import type { Empresa, User } from '../types';

export interface LoginResponse {
  token: string;
  refreshToken?: string;
  user: User;
}

export async function login(email: string, password: string): Promise<LoginResponse> {
  const { data } = await api.post<LoginResponse>('/auth/login', { email, password });
  return data;
}

export async function activate(
  token: string,
  password: string,
  nombre?: string,
): Promise<LoginResponse> {
  const { data } = await api.post<LoginResponse>('/auth/activate', { token, password, nombre });
  return data;
}

export async function me(): Promise<{ user: User; empresas: Empresa[] }> {
  const { data } = await api.get<{ user: User; empresas: Empresa[] }>('/auth/me');
  return data;
}
